export const GET_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/get_land_record_of_sup_assessment';
export const GET_SINGLE_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/get_single_land_record_of_sup_assessment';
export const CREATE_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/create_land_record_of_sup_assessment';
export const UPDATE_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/update_land_record_of_sup_assessment';
export const REMOVE_LAND_RECORD_OF_SUP_ASSESSMENT = '/land/remove_land_record_of_sup_assessment';

export const FIND_TDN = 'land/find_tdn';
export const GET_TDN = 'land/get_tdn';

export const FORM_DATA = {
  pin: '',
  arp_no: '',
  td_no: '',
  total_assessed_value: '',
  previous_owner: '',
  effectivity_of_assessment: '',
  ar_page_no: '',
  recording_person: '',
  date: '',
  previous_land_application_id: '',
}